module.exports = __webpack_public_path__ + "img/icon.c5d49577.png";